export default __webpack_public_path__ + "static/media/Ellipse 116.fe43cd28.svg";